<kiwi-competitive-intelligence
    [barChartLabel]="'common.budget'"
    [teamValueLabelKey]="'common.budget'"
    [comparisonStudy]="study">
</kiwi-competitive-intelligence>
